import { singleton, inject } from "tsyringe";

import { WindowPopupConnecter } from "@/features/connect-common-accounts/services/workers/WindowPopupConnecter";
import { ListenMessageHandler } from "@/features/connect-common-accounts/services/workers/ListenMessageHandler";

import type {
    CommonAccountsPath,
    ConnectCommonAccountsOptions,
} from "@/features/connect-common-accounts/models/interface";

@singleton()
export class ConnectCommonAccountsPathUsecase {
    constructor(
        @inject(WindowPopupConnecter)
        private readonly windowPopupHandler: WindowPopupConnecter,
        @inject(ListenMessageHandler)
        private readonly listenMessageHandler: ListenMessageHandler,
    ) {}

    public execute = (path: CommonAccountsPath, options?: ConnectCommonAccountsOptions) => {
        const popup = this.windowPopupHandler.connect(path, options);

        if (popup) {
            this.listenMessageHandler.listen(popup);
        }
    };
}
